// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2HZCa","clinicsSelect":"TableHeading_clinicsSelect__1roOX"};